import { render, staticRenderFns } from "./repayReporta.vue?vue&type=template&id=2af206cd&scoped=true"
import script from "./repayReporta.vue?vue&type=script&lang=js"
export * from "./repayReporta.vue?vue&type=script&lang=js"
import style0 from "./repayReporta.vue?vue&type=style&index=0&id=2af206cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af206cd",
  null
  
)

export default component.exports